export default "__VITE_ASSET__lstMB025__"